var localService = /** @class */ (function () {
    function localService() {
    }
    localService.get = function (key) {
        try {
            return JSON.parse(localStorage.getItem(key));
        }
        catch (e) {
            console.error(e);
            return localStorage.getItem(key);
        }
    };
    localService.set = function (key, value) {
        if (typeof value === 'string') {
            localStorage.setItem(key, value);
        }
        else {
            localStorage.setItem(key, JSON.stringify(value));
        }
    };
    localService.remove = function (key) {
        localStorage.removeItem(key);
    };
    localService.clear = function () {
        localStorage.clear();
    };
    return localService;
}());
export { localService };
